import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { AppSettingsService, hd, TicketService, UploadService } from '@nx-fe/services';
import { Observable } from 'rxjs';
import { TicketContextService } from '../../services/ticket-context.service';

type IUploadConfig = hd.IUploadConfig;

/** Defines the interface for the attachment service configuration object */
//TODO: extract interface to general
export interface IAttachmentServiceConfig {
  /** The maximum supported file size, in megabytes */
  maxFileSize: number;
  downloadExpiryMilliseconds: number;
  maxPreviewSize: number;
}

export interface IAttachmentModel {
  /** The attachment id */
  attachmentId: string;

  /** The file name to be used when attachment is downloaded */
  fileName: string;

  /** The size of the file. Returned when the file is uploaded */
  fileSize?: number;

  thumbnail?: string;
}

@Injectable()
export class AttachmentService {
  constructor(
    private $http: HttpClient,
    private appSettingsService: AppSettingsService,
    private uploadService: UploadService,
    private ticketService: TicketService,
    private ticketContextService: TicketContextService
  ) {}

  /** @See IAttachmentService.getConfig */
  public getConfig = (): Observable<IAttachmentServiceConfig> =>
    this.$http.get<IAttachmentServiceConfig>(this.appSettingsService.attachmentServiceUrl + 'config');

  private getAttachmentUrl = (): string => {
    return this.ticketService.getTicketAttachmentUrl(this.ticketContextService.ticket.ticketId);
  };

  /** @See IAttachmentService.uploadAttachment */
  public uploadAttachment = (file: File, displayName?: string): Observable<any> => {
    // Define file upload config
    const config: IUploadConfig = {
      url: this.getAttachmentUrl() + 'upload',
      data: {
        file,
      },
      params: {
        displayName,
      },
    };

    return this.uploadService.upload(config);
  };
}
